import { render, staticRenderFns } from "./ViberTemplates.vue?vue&type=template&id=507f0460&"
import script from "./ViberTemplates.vue?vue&type=script&lang=ts&"
export * from "./ViberTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports